export default __webpack_public_path__ + "static/media/mlr-2-rMAX.0ed7ebc3.avif";